// extracted by mini-css-extract-plugin
export default {"root":"GNXC0","button":"cMzyx","text":"Lp0vv"};